import React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { withRouter } from 'react-router-dom'
import { TidewaysContext } from './app/context'
import { Entity } from './app/entity'
import Navigator from './app/navigator'
import { MonitorOperation, ProfilerOperation } from './domain/Operation'
import OperationRow, { TransactionMenuType } from './monitor/transaction-table-row-item'
import Graph from './monitor/operation/graph'
import Histogram from './monitor/operation/histogram'
import Profiles from './monitor/operation/profiles'
import TransactionNavigation from './monitor/transaction-navigation'
import OperationGraphHeader from './operation/graphheader'
import { ApplicationState } from './redux/ApplicationState'
import { Box, BoxBody } from './ui/box'
import { Col } from './ui/grid'

interface MatchParameters {
    operation: string
}

interface StateProps {
    navigator: Navigator
    tidewaysContext: TidewaysContext
    taggedVariants: Entity<{ operations: MonitorOperation[] }>
}

type Props = StateProps & Entity<ProfilerOperation> & RouteComponentProps<MatchParameters>

export class Operation extends React.Component<Props> {
    public render() {
        if (this.props.loading || !this.props.data) {
            return (
                <div className="row">
                    <div className="col-md-12 content-header">
                        <h1>Loading…</h1>
                    </div>
                </div>
            )
        }

        return (
            <div className="row monitor">
                <div className="col-md-12">
                    <TransactionNavigation transaction={this.props.data} />
                </div>

                <div>
                    <div className="col-md-12 monitor">
                        {this.props.data.no_details ? (
                            <OperationGraphHeader operation={this.props.data} />
                        ) : (
                            <Graph operation={this.props.data} />
                        )}
                    </div>

                    {this.props.taggedVariants.data && this.props.taggedVariants.data.operations.length > 0 ? (
                        <Col widthMedium={12}>
                            <Box>
                                <BoxBody noPadding>
                                    <table className="table table-striped profile table-fixed">
                                        <thead>
                                            <tr>
                                                <th>Grouped by Tags</th>
                                                <th style={{ width: 100 }} className="align-right">
                                                    Requests
                                                </th>
                                                <th style={{ width: 170 }} className="align-right">
                                                    Average Response
                                                </th>
                                                <th style={{ width: 160 }} className="align-right">
                                                    Slowest Response
                                                </th>
                                                <th style={{ width: 110 }} className="align-right">
                                                    Memory
                                                </th>
                                                <th style={{ width: 110 }} className="align-right">
                                                    Failures
                                                </th>
                                                <th style={{ width: 110 }} className="align-right">
                                                    Impact
                                                </th>
                                                <th style={{ width: 110 }}>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.taggedVariants.data.operations.map(operation => (
                                                <OperationRow
                                                    full
                                                    menuType={TransactionMenuType.Edit}
                                                    key={operation.id}
                                                    operation={operation}
                                                    isTideways6={this.props.tidewaysContext.organization.isTideways6}
                                                />
                                            ))}
                                        </tbody>
                                    </table>
                                </BoxBody>
                            </Box>
                        </Col>
                    ) : null}

                    {!this.props.data.no_details ? (
                        <div className="col-md-12">
                            <Histogram />
                        </div>
                    ) : null}

                    {!this.props.data.ignored ? (
                        <div className="col-md-12">
                            <Profiles />
                        </div>
                    ) : null}
                </div>
            </div>
        )
    }
}

export default withRouter(
    connect((globalState: ApplicationState, props: RouteComponentProps<MatchParameters>) => {
        const operationId = props.match.params.operation
        const operation = globalState.operations.data[operationId] || new Entity()
        const taggedVariants = globalState.operations.tagged[operationId] || new Entity({ operations: [] })

        return {
            tidewaysContext: globalState.tidewaysContext,
            navigator: new Navigator(globalState.tidewaysContext.route),
            ...operation,
            taggedVariants,
        }
    })(Operation),
)
